<template>
  <div class="widM famliy01-check">
    <div style="display: flex; justify-content: space-between; align-items: center;">
      <p class="fntH6 fntL bold marTML marBM" style="color:#2c2c2c; width:49%;">{{ `${getTextByType(participant)} ${(idx + 1)}`}}</p>
      <button class="fntH6 marTML marBM" style="background:none; vertical-align: middle; display: flex; align-items: center;" @click="removeFamily(idx)">
        <em class="disbl marRS">삭제</em><img src="https://www.amway.co.kr/_ui/_noticeImg/2022/09/0929_NCAcmi/btn_close.png" alt="파일 삭제 버튼" class="FamilyDlt disBl">
      </button>
    </div>


    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common">
      <label for="pf23-family-relative01 txtL" class="fntP">가족관계 <span class="ico-must-astar"></span></label>
      <div class="pf12-familyWidth">
        <div class="pf23-inFo-select pf23-family-relative" style="margin-left: auto;">
          <select class="form-control" :value="participant.questions['Q218'].raw_data" 
            :id="`Q218-${resIdx}`"
            :disabled="disabled"
            :class="ishint && participant.questions['Q218'].hasError ? 'check-red' : ''"
            @change="changeFamilyRelation(resIdx, 'Q218', $event.target)"
          >
            <option value="">관계 선택</option>
            <template v-for="(family, index) in familyRelations" >
              <option :value="family.CODE" :key="index" :checked="participant.questions['Q218'].raw_data == family.CODE">{{family.LABEL}}</option>
            </template> 
          </select>
        </div>
      </div>
    </div>  

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm">
      <label for="pf23-fmaily01-Name01" class="fntP">이름(국문) <span class="ico-must-astar"></span></label>
      <div class="pf12-familyWidth txtR">
        <input
            type="text"
            name="NCAcmi_family_name01"
            maxlength="30"
            :id="`NCAcmi_name-${resIdx}`"
            :value="familyName"
            :disabled="disabled"
            @input="inputFamilyName(resIdx, $event.target)"
            oninput="javascript: this.value = this.value.replace(/[^a-z|A-Z|ㄱ-ㅎ|ㅏ-ㅣ|가-힣|-ㆍᆢ]/g, '' );"   
          />
      </div>
    </div>
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">
      *외국인의 경우 이름(영문)으로 입력
    </p>

    <div class="pf23-inFo-C padBSM padTSM pf23-inFo-common">
      <div class="pf23-input-wrap">
        <label for="pf23-fmaily01-Num01" class="fntP">휴대폰 번호<span class="ico-must-astar"></span></label>
        <div class="pf12-familyWidth txtR">
          010 -<input
              type="text"
              maxlength="8"
              placeholder="- 없이 입력"
              size="50"            
              :id="`Q200-${resIdx}`"
              :value="participant.questions['Q200'].raw_data"
              :class="(participant.questions['Q200'].hasError && participant.questions['Q200'].raw_data) ? 'check-red' : ''"          
              :disabled="disabled"
              @input="inputNumberFixWordAnswer(resIdx, 'Q200', $event.target, 8)"              
            />
        </div>
      </div>
    </div>
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;" v-if="(participant.questions['Q200'].hasError && participant.questions['Q200'].raw_data)">
      <template>🚫 010 뒤의 숫자 8자리를 입력해주세요.</template>
    </p> 
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">
      *휴대폰 번호가 없는 경우 보호자의 휴대폰 번호 입력
    </p>      

    <div class="pf23-inFo-L padBSM padTSM pf23-lineBtm">
      <label for="pf23-fmaily01-Name01" class="fntP">내국인 구분 <span class="ico-must-astar"></span></label>
      <div class="pf12-familyWidth">
        <div class="amway-theme">
          <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
            <label class="amw-radio-wrap radio-label focus">
              <input
                type="radio"
                class="amw-global-radio"
                value="DOMESTIC"
                :id="`Q201-${resIdx}`"
                :name="`domestic-radio-${resIdx}`"
                :checked="participant.questions['Q201'].raw_data === 'DOMESTIC'"
                :disabled="disabled"
                @change="inputRadioDomesticAnswer(resIdx, 'Q201', 'DOMESTIC'); inputSelectAnswer(resIdx, 'Q207', null, '대한민국');"                
              />
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">내국인</span>
            </label>

            <label class="amw-radio-wrap radio-label focus">
              <input
                type="radio"
                class="amw-global-radio"
                value="FOREIGNER"
                :name="`domestic-radio-${resIdx}`"
                :checked="participant.questions['Q201'].raw_data === 'FOREIGNER'"
                :disabled="disabled"
                @change="inputRadioDomesticAnswer(resIdx, 'Q201', 'FOREIGNER'); inputSelectAnswer(resIdx, 'Q207', null, '');"
              />
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">외국인</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div id="pf23-family01-personal" class="padTSM padBSM">
      <!-- 8.30 주민등록번호 영역 추가 및 수정 / .pf23-input-wrap 추가 -->
      <div class="pf23-inFo-L pf23-inFo-common">
        <label for="pf23-family01-Personal01-1" class="fntP txtL">
          {{ participant.questions['Q201'].raw_data == 'FOREIGNER' ? '외국인등록번호' : '주민등록번호' }}<span class="ico-must-astar"></span>
        </label>
        <div class="pf12-familyWidth">
          <div class="txtR pf12-familyWidth-personal">
            <em class="txtR disIb">
              <input
                type="text"
                class="NCAcmi_num"
                style="width:45%; "
                maxlength="6"
                :id="`Q202-${resIdx}`"
                :name="`NCAcmi_personal${resIdx}-1`" 
                :class="(participant.questions['Q202'].hasError && participant.questions['Q202'].raw_data) ? 'check-red' : ''"
                :value="participant.questions['Q202'].raw_data"
                :disabled="disabled || participant.questions['Q201'].hasError"
                @input="inputJuminFirstNumber(resIdx, 'Q202', $event.target, true)"
                /><span class="disIb txtC" style="width:10%;">-
                </span><input
                type="text"
                class="NCAcmi_num"
                style="width:45%; "
                maxlength="7"
                :id="`Q203-${resIdx}`"
                :name="`NCAcmi_personal${resIdx}-2`"
                :class="(participant.questions['Q203'].hasError && participant.questions['Q203'].raw_data) ? 'check-red' : ''"
                :value="participant.questions['Q203'].raw_data"
                :disabled="disabled || participant.questions['Q201'].hasError"
                @input="inputJuminLastNumber(resIdx, 'Q203', $event.target, 'Q206');"                  
              />
            </em>
          </div>
        </div>
      </div>
    </div>
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">
      <template v-if="(participant.questions['Q202'].hasError || participant.questions['Q203'].hasError) && (participant.questions['Q202'].raw_data || participant.questions['Q203'].raw_data)">
      🚫 {{juminHasError}}
      </template>
    </p>

    <div class="pf23-inFo-L padBSM padTSM pf23-lineBtm">
      <p class="fntP">성별 <span class="ico-must-astar"></span></p>
      <div class="pf12-familyWidth">
        <div class="amway-theme">
          <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
            <label class="amw-radio-wrap radio-label focus">
              <input
                type="radio"
                class="amw-global-radio"
                value="FEMALE"
                :id="`Q206-${resIdx}`"
                :name="`-radio-${resIdx}`"
                :checked="participant.questions['Q206'].raw_data === 'FEMALE'"
                :disabled="true"
              />
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">여성</span>
            </label>

            <label class="amw-radio-wrap radio-label focus">
              <input
                type="radio"
                class="amw-global-radio"
                value="MALE"
                :name="`sex-radio-${resIdx}`"
                :checked="participant.questions['Q206'].raw_data === 'MALE'"
                :disabled="true"
              />
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">남성</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">* 주민/외국인 등록번호에 따라 자동선택됩니다.</p>

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm" style="border-top:1px solid #e3e3e3;">
      <label for="pf23-family01-en-first01" class="fntP">여권 영문 성 <span class="ico-must-astar"></span></label>
      <div class="pf12-familyWidth txtR">
        <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="30"
          placeholder="여권 영문 성"
          :id="`Q204-${resIdx}`"
          :name="`NCAcmi_engname01${resIdx}-1`" 
          :class="(participant.questions['Q204'].hasError && participant.questions['Q204'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q204'].raw_data"
          :disabled="disabled"          
          @input="inputEngAnswer(resIdx, 'Q204', $event.target)"
        />
      </div>      
    </div>  
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="(participant.questions['Q204'].hasError && participant.questions['Q204'].raw_data)">🚫 2자 이상 영문으로 입력해주세요.</template></p>
    
                  

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm">
      <label for="pf23-family01-en-name01" class="fntP">여권 영문 이름 <span class="ico-must-astar"></span></label>
      <div class="pf12-familyWidth txtR">
        <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="30"
          placeholder="여권 영문 이름"
          :id="`Q205-${resIdx}`"
          :name="`NCAcmi_engname02${resIdx}-1`" 
          :class="(participant.questions['Q205'].hasError && participant.questions['Q205'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q205'].raw_data"
          :disabled="disabled"          
          @input="inputEngAnswer(resIdx, 'Q205', $event.target)"
        />
      </div>
    </div>
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="(participant.questions['Q205'].hasError && participant.questions['Q205'].raw_data)">🚫 2자 이상 영문으로 입력해주세요.</template></p>

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm">
      <p class="fntP">국가 <span class="ico-must-astar"></span></p>
      <div class="pf12-familyWidth">
        <div class="pf23-inFo-select pf23-country" style="margin-left: auto;">
          <select class="form-control" :value="participant.questions['Q207'].raw_data" 
            :id="`Q207-${resIdx}`"
            :disabled="disabled || participant.questions['Q201'].raw_data === 'DOMESTIC' "
            :class="ishint && participant.questions['Q207'].hasError ? 'check-red' : ''"
            @change="inputSelectAnswer(resIdx, 'Q207', $event.target)"
          >
            <option value="">국가선택</option>
            <template v-for="(country, index) in counties" >
              <option v-show="participant.questions['Q201'].raw_data !== 'DOMESTIC' && country.COUNTRY_KOR_NM !== '대한민국'" :value="country.COUNTRY_KOR_NM" :key="index" :checked="participant.questions['Q207'].raw_data == country.COUNTRY_KOR_NM">{{country.COUNTRY_ISO_WORD3}} - {{ country.COUNTRY_KOR_NM}}</option>
            </template> 
          </select>
        </div>
      </div>
    </div>
    <p v-if="participant.questions['Q201'].raw_data === 'DOMESTIC'" class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">* 내국인은 대한민국 자동 선택됩니다.</p>
    <p v-if="participant.questions['Q201'].raw_data !== 'DOMESTIC'" class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="ishint && participant.questions['Q207'].hasError">🚫 국가를 선택해 주세요.</template></p>

    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm">
      <div class="pf23-inFo-L">
        <label for="pf23-family01-Passport-Num01" class="fntP">여권 번호 <span class="ico-must-astar"></span></label>
        <div class="pf12-familyWidth txtR">
          <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="20"
          :id="`Q208-${resIdx}`"
          :name="`NCAcmi_passportnumber${resIdx}-1`" 
          :class="(participant.questions['Q208'].hasError && participant.questions['Q208'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q208'].raw_data"
          :disabled="disabled"
          @input="inputPassportAnswer(resIdx, 'Q208', $event.target)"          
        />
        </div>
      </div>
    </div>
    <!--<p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;"><template v-if="(participant.questions['Q208'].hasError && participant.questions['Q208'].raw_data)">🚫 여권 번호를 입력해 주시기 바랍니다.</template></p>-->

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common">
      <p class="fntP">여권 발급일 <span class="ico-must-astar"></span></p>
      <div class="pf12-familyWidth txtR">
        <input
          type="date"
          class="NCAcmi_num"
          size="50"
          maxlength="50"
          :id="`Q209-${resIdx}`"
          :name="`NCAcmi_passportfrom${resIdx}`" 
          :class="ishint && participant.questions['Q209'].hasError ? 'check-red' : ''"
          :value="participant.questions['Q209'].raw_data"
          :disabled="disabled"
          :max="today"
          @change="inputPassportDateAnswer(resIdx, 'Q209', $event.target)"          
        />
      </div>
    </div>
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="ishint && participant.questions['Q209'].hasError">🚫 {{participant.questions['Q209'].remarks ? participant.questions['Q209'].remarks : "여권발급일을 선택해주세요."}}</template></p>

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common">
      <p class="fntP">여권 만료일 <span class="ico-must-astar"></span></p>
      <div class="pf12-familyWidth txtR">
        <input
          type="date"
          class="NCAcmi_num"
          size="50"
          maxlength="50"
          :id="`Q210-${resIdx}`"
          :name="`NCAcmi_passportend${resIdx}`" 
          :class="ishint && participant.questions['Q210'].hasError ? 'check-red' : ''"
          :value="participant.questions['Q210'].raw_data"
          :disabled="disabled"
          :min="today"
          @change="inputPassportDateAnswer(resIdx, 'Q210', $event.target); navtiveAlert('여권 만료일은 출국일로부터 6개월 이상이어야 합니다.\n잔여 유효기간이 6개월 미만인 경우 여권을 재발급 받은 후 담당 여행사 (02-2022-6520)로 연락주시기 바랍니다.');"          
        />
      </div>
    </div>
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="ishint && participant.questions['Q210'].hasError">🚫 {{participant.questions['Q210'].remarks ? participant.questions['Q210'].remarks : "여권만료일을 선택해주세요."}}</template></p>

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm" style="border-top:1px solid #e3e3e3;">
      <label for="pf23-family01-height01" class="fntP">신장 <span class="ico-must-astar"></span></label>
      <div class="pf12-familyWidth txtR">
        <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="3"
          placeholder="cm 단위"
          :id="`Q211-${resIdx}`"
          :name="`NCAcmi_passportnumber${resIdx}-1`" 
          :class="(ishint && participant.questions['Q211'].hasError) ? 'check-red' : ''"
          :value="participant.questions['Q211'].raw_data"
          :disabled="disabled"          
          @input="inputNumberAnswer(resIdx, 'Q211', $event.target)"
        />
      </div>
    </div>  
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">
      <template v-if="(ishint && participant.questions['Q211'].hasError)">🚫 신장을 입력해 주시기 바랍니다.</template>
    </p>

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm" style="border-top:1px solid #e3e3e3;">
      <label for="pf23-family01-height01" class="fntP">체중 <span class="ico-must-astar"></span></label>
      <div class="pf12-familyWidth txtR">
        <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="3"
          placeholder="kg 단위"
          :id="`Q212-${resIdx}`"
          :name="`NCAcmi_passportnumber${resIdx}-1`" 
          :class="(ishint && participant.questions['Q212'].hasError) ? 'check-red' : ''"
          :value="participant.questions['Q212'].raw_data"
          :disabled="disabled"          
          @input="inputNumberAnswer(resIdx, 'Q212', $event.target)"
        />
      </div>
    </div>  
    <p class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">
      <template v-if="(ishint && participant.questions['Q212'].hasError)">🚫 체중을 입력해 주시기 바랍니다.</template>
    </p>

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm" style="border-top:1px solid #e3e3e3;">
      <label for="pf23-family01-footSize01" class="fntP">신발 사이즈 <span class="ico-must-astar"></span></label>
      <div class="pf12-familyWidth">
        <div class="pf23-inFo-select pf23-footSize" style="margin-left: auto;">
          <select class="form-control" name="pf23-family01-footSize01" :value="participant.questions['Q213'].raw_data" 
            @change="inputSelectAnswer(resIdx, 'Q213', $event.target)"
            :id="`Q213-${resIdx}`"
            :disabled="disabled"
            :class="ishint && participant.questions['Q213'].hasError ? 'check-red' : ''"
          >
            <option value="">사이즈선택</option>
            <template v-for="(item, index) in shoeSize" >
              <option :value="item.CODE" :key="index" :checked="participant.questions['Q213'].raw_data == item.CODE">{{item.LABEL}}</option>
            </template> 
          </select>
        </div>
      </div>
    </div> 
    <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">* 신발 사이즈 195mm 이하는 스키만 선택이 가능합니다.</p>
    <p v-if="(ishint && participant.questions['Q213'].hasError)" class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">🚫 신발사이즈를 선택해 주세요.</p>

    <div class="pf23-inFo-L padBSM padTSM pf23-lineBtm">
      <p class="fntP">스키/보드 <span class="ico-must-astar"></span></p>
      <div class="pf12-familyWidth">
        <div class="amway-theme">
          <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
            <label class="amw-radio-wrap radio-label focus">
              <input
                type="radio"
                class="amw-global-radio"
                value="스키"
                :name="`reports-radio-${resIdx}`"
                :id="`Q214-${resIdx}`"
                :checked="participant.questions['Q214'].raw_data === '스키'"
                :disabled="disabled"
                @change="inputRadioAnswer(`${resIdx}`, 'Q214', '스키');"                
              />
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">스키</span>
            </label>
            <label class="amw-radio-wrap radio-label focus">
              <input
                type="radio"
                class="amw-global-radio"
                value="보드"
                :name="`reports-radio-${resIdx}`"
                :checked="participant.questions['Q214'].raw_data === '보드'"
                :disabled="disabled"
                @change="inputRadioAnswer(`${resIdx}`, 'Q214', '보드');"                
              />
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">보드</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="pf23-inFo-L padBSM padTSM pf23-inFo-common pf23-lineBtm" style="border-top:1px solid #e3e3e3;">
      <label for="pf23-family01-sportLv01" class="fntP">스키/보드 레벨 <span class="ico-must-astar"></span></label>
      <div class="pf12-familyWidth">
        <div class="pf23-inFo-select pf23-sportLv" style="margin-left: auto;">
          <select class="form-control" :value="participant.questions['Q215'].raw_data" 
            @change="inputSelectAnswer(resIdx, 'Q215', $event.target)"
            :id="`Q215-${resIdx}`"
            :disabled="disabled || participant.questions['Q215'].raw_data === 'DOMESTIC' "
            :class="ishint && participant.questions['Q215'].hasError ? 'check-red' : ''"
          >
            <option value="">레벨선택</option>
            <template v-for="(item, index) in sportLevel" >
              <option :value="item.CODE" :key="index" :checked="participant.questions['Q215'].raw_data == item.CODE">{{item.LABEL}}</option>
            </template> 
          </select>
        </div>
      </div>
    </div>  
    <p v-if="(ishint && participant.questions['Q215'].hasError)" class="marTS fntE hintHeight" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">🚫 레벨을 선택해 주세요.</p>

    <div class="padTSM pf23-lineBtm">
      <p class="fntP">안전 확인<span class="ico-must-astar"></span></p>
      <p class="fntP padTSM ">‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)</p>
    
      <div class="pf23-inFo-safe-L marTSM">
        <div class="amway-theme" style="width:55%;">
          <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
            <label class="amw-radio-wrap radio-label focus">
              <input
                type="radio"
                :name="`safe-radio-${resIdx}`"
                class="amw-global-radio"
                value="Y"
                :id="`Q217-${resIdx}`"
                @change="inputRadioAnswer(`${resIdx}`, 'Q217', 'Y');"
                :checked="participant.questions['Q217'].raw_data === 'Y'"
                :disabled="disabled"
              />
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">예</span>
            </label>
            <label class="amw-radio-wrap radio-label focus" style="margin-right:1.5em;">
              <input 
                type="radio"
                :name="`safe-radio-${resIdx}`"
                class="amw-global-radio"
                value="N"
                @change="inputRadioAnswer(`${resIdx}`, 'Q217', 'N');"
                :checked="participant.questions['Q217'].raw_data === 'N'"
                :disabled="disabled">
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">아니오</span>
            </label>
          </div>
        </div>
      </div>

      <p class="marTS fntE" style="color:#0075a4; text-indent: -0.6em; padding-left: 0.6em; padding-bottom: 0.6em;">* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에
        작성하여 주시기 바랍니다.</p> 
    </div>

    <!-- 여권 사본 -->
    <SurveyAttachmentFamily
      :class="{ NCAcmi_lineBtm: showPaymentForm }"
      :participant="participant"
      :sq-code="'Q220'"
      :disabled="disabled"
      :id="`Q220-${resIdx}`"
    />

  </div>
</template>

<script>
import { CommonMethodMixin } from '../mixins'
import { mapGetters, mapState } from 'vuex'
import { SURVEY_SAPPORO, GET_DATA_IDX_BY_TYPE, REMOVE_FAMILY, ATTENDING_LIST, IS_FAMILY_NEED_PAYMENT, INFO_AVAILABLE,
  GET_CODE_COUNTRY,  GET_CODE_TODAY,  GET_CODE_PASSPORT_DATE,  GET_CODE_SHOE_SIZE,  GET_CODE_SPORT_LEVEL, GET_CODE_FAMILY_REL, GET_PERSONS_EXCLUDING_FAMILY } from '@/store/actions/survey'
import SurveyAttachmentFamily from './SurveyAttachmentFamily.vue'
import SurveyParticipantPayment from './SurveyParticipantPayment.vue'
import { getMessage } from '@/utils/survey'

export default {
  name: 'SurveyParticipantFamily',
  mixins: [CommonMethodMixin],
  components: {
    SurveyAttachmentFamily,
    SurveyParticipantPayment,
  },
  props: {
    idx: {
      type: Number,
      required: true,
    },
    participant: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      
    }
  },
  computed: {
    ...mapState(SURVEY_SAPPORO, {
      hint: state => state.hint,
    }),
    ...mapGetters(SURVEY_SAPPORO, {
      getResponseIdx: GET_DATA_IDX_BY_TYPE,
      isFamilyNeedPayment: IS_FAMILY_NEED_PAYMENT,
      infoAvailable: INFO_AVAILABLE,
      counties : GET_CODE_COUNTRY,
      today: GET_CODE_TODAY,
      passportDate: GET_CODE_PASSPORT_DATE,
      shoeSize: GET_CODE_SHOE_SIZE,
      sportLevel: GET_CODE_SPORT_LEVEL,
      familyRelations: GET_CODE_FAMILY_REL,
      personsExcludingFamily: GET_PERSONS_EXCLUDING_FAMILY,
    }),
    disabled() {
      return !this.infoAvailable;
    },
    resIdx() {
      return this.getResponseIdx(this.participant.type, this.participant.type_seq);
    },
    // 동반 가족 결제 폼
    showPaymentForm() {
      return this.isFamilyNeedPayment(this.participant.type_seq);
    },
    ishint () {
      return !this.disabled && this.hint
    },
    juminHasError() { 
        const firstError = this.participant.questions['Q202'].hasError;
        const secondError = this.participant.questions['Q203'].hasError;
        const domestic = this.participant.questions['Q201'].hasError;

        if (domestic) { 
          return "내/외국인 여부를 선택해 주세요."
        } else if (firstError && this.participant.questions['Q202'].remarks) { 
          return this.participant.questions['Q202'].remarks;
        } else if (secondError && this.participant.questions['Q203'].remarks) { 
          return this.participant.questions['Q203'].remarks;
        } else if (firstError || secondError) { 
          return "숫자 13자리를 입력해주세요."
        }
    },
    familyName () { 
      return this.participant.name || '';
    } 
  },
  methods: {
    removeFamily(idx) {
      if(confirm(getMessage('CONFIRM_REMOVE_FAMILY', (idx+1)))) {
        this.$store.dispatch(`${SURVEY_SAPPORO}/${REMOVE_FAMILY}`, this.resIdx);
        console.log(`[동반가족 삭제] 삭제대상 : ${idx+1} 명`, )
      }
    },
    navtiveAlert(msg){
      window.alert(msg);
    },
    changeFamilyRelation(idx, sq_code, target){      
      this.inputSelectAnswer(idx, sq_code, target);
      console.log(`[동반가족 가족관계 변경] 직계자녀 제외 인원 : ${this.personsExcludingFamily} 명`)
      if (this.personsExcludingFamily > 4) { 
        alert(getMessage('CONFIRM_ATTENDANT_RULE4'))
      }
    }
  },
}
</script>

<style>
.hintHeight { 
  min-height: 21px;
}
</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyParticipantFamily.vue